import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Factory, Play, Pause, CheckCircle, AlertCircle, TrendingUp, Users, Clock, Package } from 'lucide-react';
export function FactoryProduction() {
  const productionLines = [{
    id: 'LINE-01',
    name: 'Production Line 1',
    product: 'Indomie Goreng Special',
    poNumber: 'PO-2023-001',
    status: 'running',
    statusLabel: 'Running',
    progress: 65,
    target: 500,
    produced: 325,
    remaining: 175,
    efficiency: 92,
    workers: 12,
    shift: 'Shift 1 (07:00-15:00)',
    estimatedCompletion: '13 Okt 2023, 14:00'
  }, {
    id: 'LINE-02',
    name: 'Production Line 2',
    product: 'Indomie Soto',
    poNumber: 'PO-2023-001',
    status: 'running',
    statusLabel: 'Running',
    progress: 78,
    target: 300,
    produced: 234,
    remaining: 66,
    efficiency: 88,
    workers: 10,
    shift: 'Shift 1 (07:00-15:00)',
    estimatedCompletion: '13 Okt 2023, 12:00'
  }, {
    id: 'LINE-03',
    name: 'Production Line 3',
    product: 'Indomie Ayam Bawang',
    poNumber: 'PO-2023-005',
    status: 'idle',
    statusLabel: 'Idle',
    progress: 0,
    target: 0,
    produced: 0,
    remaining: 0,
    efficiency: 0,
    workers: 0,
    shift: '-',
    estimatedCompletion: '-'
  }];
  const qualityMetrics = [{
    metric: 'Pass Rate',
    value: 98.8,
    target: 98,
    status: 'good'
  }, {
    metric: 'Defect Rate',
    value: 1.2,
    target: 2,
    status: 'good'
  }, {
    metric: 'Rework Rate',
    value: 0.8,
    target: 1.5,
    status: 'good'
  }];
  return <div className="space-y-6" data-id="element-1971">
      {/* Header */}
      <div data-id="element-1972">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-1973">
          Production Management
        </h2>
        <p className="text-sm text-slate-500 mt-1" data-id="element-1974">
          Monitor dan kelola produksi real-time
        </p>
      </div>

      {/* KPIs */}
      <div className="grid grid-cols-4 gap-4" data-id="element-1975">
        <Card className="p-5 bg-gradient-to-br from-green-50 to-green-100 border-green-200" data-id="element-1976">
          <div className="flex items-center justify-between mb-3" data-id="element-1977">
            <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-1978">
              <Factory className="w-6 h-6 text-white" data-id="element-1979" />
            </div>
            <Badge className="bg-green-200 text-green-800 border-0" data-id="element-1980">
              Active
            </Badge>
          </div>
          <p className="text-sm text-green-700 mb-1" data-id="element-1981">Active Lines</p>
          <p className="text-4xl font-bold text-green-900" data-id="element-1982">2/3</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-1983">67% utilization</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" data-id="element-1984">
          <div className="flex items-center justify-between mb-3" data-id="element-1985">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-1986">
              <Package className="w-6 h-6 text-white" data-id="element-1987" />
            </div>
            <Badge className="bg-blue-200 text-blue-800 border-0" data-id="element-1988">+12%</Badge>
          </div>
          <p className="text-sm text-blue-700 mb-1" data-id="element-1989">Today's Output</p>
          <p className="text-4xl font-bold text-blue-900" data-id="element-1990">559</p>
          <p className="text-xs text-blue-600 mt-1" data-id="element-1991">Karton produced</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-violet-50 to-violet-100 border-violet-200" data-id="element-1992">
          <div className="flex items-center justify-between mb-3" data-id="element-1993">
            <div className="w-12 h-12 bg-violet-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-1994">
              <TrendingUp className="w-6 h-6 text-white" data-id="element-1995" />
            </div>
            <Badge className="bg-violet-200 text-violet-800 border-0" data-id="element-1996">
              Good
            </Badge>
          </div>
          <p className="text-sm text-violet-700 mb-1" data-id="element-1997">Avg Efficiency</p>
          <p className="text-4xl font-bold text-violet-900" data-id="element-1998">90%</p>
          <p className="text-xs text-violet-600 mt-1" data-id="element-1999">Target: 85%</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200" data-id="element-2000">
          <div className="flex items-center justify-between mb-3" data-id="element-2001">
            <div className="w-12 h-12 bg-amber-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-2002">
              <Users className="w-6 h-6 text-white" data-id="element-2003" />
            </div>
            <Badge className="bg-amber-200 text-amber-800 border-0" data-id="element-2004">
              On Duty
            </Badge>
          </div>
          <p className="text-sm text-amber-700 mb-1" data-id="element-2005">Workers</p>
          <p className="text-4xl font-bold text-amber-900" data-id="element-2006">22</p>
          <p className="text-xs text-amber-600 mt-1" data-id="element-2007">Shift 1 active</p>
        </Card>
      </div>

      {/* Production Lines */}
      <div className="space-y-4" data-id="element-2008">
        {productionLines.map(line => <Card key={line.id} className="p-6" data-id="element-2009">
            <div className="flex items-start gap-6" data-id="element-2010">
              {/* Status Icon */}
              <div className="flex-shrink-0" data-id="element-2011">
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center shadow-lg ${line.status === 'running' ? 'bg-gradient-to-br from-green-500 to-green-600' : 'bg-gradient-to-br from-slate-400 to-slate-500'}`} data-id="element-2012">
                  {line.status === 'running' ? <Play className="w-8 h-8 text-white" data-id="element-2013" /> : <Pause className="w-8 h-8 text-white" data-id="element-2014" />}
                </div>
              </div>

              {/* Line Info */}
              <div className="flex-1 min-w-0" data-id="element-2015">
                <div className="flex items-start justify-between mb-3" data-id="element-2016">
                  <div data-id="element-2017">
                    <div className="flex items-center gap-3 mb-2" data-id="element-2018">
                      <h3 className="text-xl font-bold text-slate-900" data-id="element-2019">
                        {line.name}
                      </h3>
                      <Badge variant={line.status === 'running' ? 'success' : 'neutral'} data-id="element-2020">
                        {line.statusLabel}
                      </Badge>
                    </div>
                    {line.status === 'running' && <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-2021">
                        <span className="font-medium" data-id="element-2022">{line.product}</span>
                        <span className="text-slate-400" data-id="element-2023">•</span>
                        <span data-id="element-2024">PO: {line.poNumber}</span>
                      </div>}
                  </div>
                  {line.status === 'running' && <div className="text-right" data-id="element-2025">
                      <p className="text-sm text-slate-600 mb-1" data-id="element-2026">Efficiency</p>
                      <p className="text-2xl font-bold text-green-600" data-id="element-2027">
                        {line.efficiency}%
                      </p>
                    </div>}
                </div>

                {line.status === 'running' ? <>
                    {/* Progress */}
                    <div className="mb-4" data-id="element-2028">
                      <div className="flex justify-between items-center mb-2" data-id="element-2029">
                        <span className="text-sm font-medium text-slate-700" data-id="element-2030">
                          Production Progress
                        </span>
                        <span className="text-sm font-bold text-slate-900" data-id="element-2031">
                          {line.produced} / {line.target} Karton (
                          {line.progress}%)
                        </span>
                      </div>
                      <div className="w-full h-3 bg-slate-200 rounded-full overflow-hidden" data-id="element-2032">
                        <div className="h-full bg-gradient-to-r from-green-500 to-green-600 rounded-full" style={{
                    width: `${line.progress}%`
                  }} data-id="element-2033"></div>
                      </div>
                      <p className="text-xs text-slate-600 mt-1" data-id="element-2034">
                        Remaining: {line.remaining} Karton • Est. completion:{' '}
                        {line.estimatedCompletion}
                      </p>
                    </div>

                    {/* Details */}
                    <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-2035">
                      <div className="p-3 bg-slate-50 rounded-lg" data-id="element-2036">
                        <p className="text-xs text-slate-600 mb-1" data-id="element-2037">Workers</p>
                        <p className="text-lg font-bold text-slate-900" data-id="element-2038">
                          {line.workers} people
                        </p>
                      </div>
                      <div className="p-3 bg-slate-50 rounded-lg" data-id="element-2039">
                        <p className="text-xs text-slate-600 mb-1" data-id="element-2040">Shift</p>
                        <p className="text-lg font-bold text-slate-900" data-id="element-2041">
                          {line.shift}
                        </p>
                      </div>
                      <div className="p-3 bg-slate-50 rounded-lg" data-id="element-2042">
                        <p className="text-xs text-slate-600 mb-1" data-id="element-2043">Status</p>
                        <p className="text-lg font-bold text-green-600" data-id="element-2044">
                          On Track
                        </p>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="flex gap-2 pt-4 border-t border-slate-200" data-id="element-2045">
                      <Button variant="outline" size="sm" icon={<Pause className="w-4 h-4" data-id="element-2047" />} data-id="element-2046">
                        Pause Line
                      </Button>
                      <Button variant="outline" size="sm" data-id="element-2048">
                        View Details
                      </Button>
                    </div>
                  </> : <div className="py-8 text-center" data-id="element-2049">
                    <p className="text-slate-500 mb-4" data-id="element-2050">
                      Production line is idle
                    </p>
                    <Button variant="primary" size="sm" icon={<Play className="w-4 h-4" data-id="element-2052" />} data-id="element-2051">
                      Start Production
                    </Button>
                  </div>}
              </div>
            </div>
          </Card>)}
      </div>

      {/* Quality Metrics */}
      <Card className="p-6" data-id="element-2053">
        <h3 className="font-bold text-lg text-slate-900 mb-6" data-id="element-2054">
          Quality Control Metrics
        </h3>
        <div className="grid grid-cols-3 gap-6" data-id="element-2055">
          {qualityMetrics.map((metric, i) => <div key={i} data-id="element-2056">
              <div className="flex justify-between items-center mb-2" data-id="element-2057">
                <span className="text-sm text-slate-600" data-id="element-2058">{metric.metric}</span>
                <span className="text-sm font-bold text-green-600" data-id="element-2059">
                  {metric.value}%
                </span>
              </div>
              <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-2060">
                <div className="h-full bg-green-500 rounded-full" style={{
              width: `${metric.value / metric.target * 100}%`
            }} data-id="element-2061"></div>
              </div>
              <p className="text-xs text-slate-500 mt-1" data-id="element-2062">
                Target: {metric.target}%
              </p>
            </div>)}
        </div>
      </Card>
    </div>;
}